import React from 'react'

import Grid from 'components/Grid'
import Review from 'components/Review'

import TextBase from '../TextBase'

import classes from './Snippets.module.scss'

const Snippets = ({ text, htmlText, snippets }) => {
  return (
    <>
      <TextBase text={text} htmlText={htmlText} />
      <Grid container spacing={3} className={classes.container}>
        {snippets?.map((snippet, index) => (
          <Grid item xs={12} sm={index === 2 ? 12 : 6} lg={4} key={snippet.id}>
            <div className={classes.root}>
              <Review.Snippet size="large" type={snippet.type} snippet={snippet} />
            </div>
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default Snippets
